<template>
  <div class="page-body">
    <div class="grid grid-cols-3 gap-5">
      <div class="col-span-3 grid grid-cols-3 items-center justify-center gap-5">
        <div class="col-span-1 text-right text-sm font-heiti">三个维度（ABC）总分</div>
        <rate-bar class="col-span-2" :yellow="{val: info.d.score * 1 || 0}" :blue="{val: 100}" />
      </div>
      <div class="col-span-3 grid grid-cols-3 items-center justify-center gap-5">
        <div class="col-span-1 text-right text-sm font-heiti">数字化基础（A）维度</div>
        <rate-bar class="col-span-2" :yellow="{val: info.partOne * 1 || 0, label: info.partOne * 1 || 0, rate: (info.partOne / 50 * 100).toFixed(1) + '%'}" :blue="{val: 50}" />
      </div>
      <div class="col-span-3 grid grid-cols-3 items-center justify-center gap-5">
        <div class="col-span-1 text-right text-sm font-heiti">数字化管理（B）维度</div>
        <rate-bar class="col-span-2" :yellow="{val: info.partTwo * 1 || 0, label: info.partTwo * 1 || 0, rate: (info.partTwo / 30 * 100).toFixed(1) + '%'}" :blue="{val: 30}" />
      </div>
      <div class="col-span-3 grid grid-cols-3 items-center justify-center gap-5">
        <div class="col-span-1 text-right text-sm font-heiti">数字化成效（C）维度</div>
        <div class="col-span-2 relative">
          <rate-bar class="w-full" :yellow="{val: info.partThree * 1 || 0, label: info.partThree * 1 || 0, rate: (info.partThree / 20 * 100).toFixed(1) + '%'}" :blue="{val: 20}" />
          <div class="absolute right-0 top-0 h-full w-2/5 flex justify-end items-center text-sm">
            <div class="text-right min-w-max font-heiti pr-2">图例</div>
            <rate-bar class="w-full" :yellow="{val: 50, label: '评分', rate: '比例%'}" :blue="{val: 100, label: '满分'}" />
          </div>
        </div>
      </div>
    </div>
    <div class="text-center font-heiti pt-2">图 2-1-1 数字化基础、管理、成效三个维度的一级指标层级评测得分</div>
    <div ref="echarts1" class="mx-auto print:w-full" style="width: 300px; height: 300px;"></div>
    <div class="text-center font-heiti">图 2-1-2 数字化基础、管理、成效三个维度的二级指标层级评测得分</div>
    <div ref="echarts2" class="max-auto text-center mx-auto" style="width: 500px; height: 250px;"></div>
    <div class="text-center font-heiti pt-2">图 2-1-3 数字化基础、管理、成效三个维度的采集项层级评测得分</div>
  </div>
</template>

<script>
import RateBar from '@/components/RateBar.vue'
import * as Echarts from 'echarts'

// 维度评测结果图表
export default {
  components: { RateBar },
  props: ['info'],
  data () {
    return {
      echarts: []
    }
  },
  mounted () {
    window.onbeforeprint = () => {
      this.echarts.forEach(v => v.resize())
    }
    this.initCharts()
  },
  methods: {
    initCharts () {
      const echarts1 = Echarts.init(this.$refs.echarts1)
      echarts1.setOption({
        grid: {
          top: '5%',
          bottom: '5%'
        },
        legend: {
          data: ['满分', '实际得分'],
          bottom: 0,
          itemWidth: 4,
          itemHeight: 4,
          icon: 'circle'
        },
        radar: {
          radius: '59%',
          center: ['50%', '50%'],
          indicator: [
            { name: '设备系统', max: 30 },
            { name: '数据采集', max: 30 },
            { name: '信息系统', max: 30 },
            { name: '信息安全', max: 30 },
            { name: '规划管理', max: 30 },
            { name: '要素保障', max: 30 },
            { name: '绿色低碳', max: 30 },
            { name: '产品质量', max: 30 },
            { name: '市场效益', max: 30 }
          ],
          axisName: {
            color: 'black'
          }
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value: [20, 15, 15, 10, 20, 26, 10, 8, 8],
                name: '满分',
                symbol: 'circle',
                symbolSize: 4,
                itemStyle: {
                  borderColor: 'rgb(0, 112, 192)',
                  borderWidth: 2
                },
                lineStyle: {
                  color: 'rgb(0, 112, 192)'
                }
              },
              {
                value: [this.info.d.partOne, this.info.d.partTwo, this.info.d.partThree, this.info.d.partFour, this.info.d.partFive, this.info.d.partSix, this.info.d.partSeven, this.info.d.partEight, this.info.d.partNine],
                name: '实际得分',
                symbol: 'circle',
                symbolSize: 4,
                itemStyle: {
                  color: 'white',
                  borderColor: 'rgb(227, 108, 10)',
                  borderWidth: 2
                },
                lineStyle: {
                  color: 'rgb(227, 108, 10)'
                }
              }
            ]
          }
        ]
      })
      this.echarts.push(echarts1)

      const echarts2 = Echarts.init(this.$refs.echarts2)
      echarts2.setOption({
        grid: {
          top: '10%',
          bottom: '10%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: { show: true }
          }
        },
        legend: {
          data: ['满分', '评分'],
          orient: 'vertical',
          right: 0,
          top: 'middle',
          itemHeight: 6
        },
        xAxis: [
          {
            type: 'category',
            data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
            axisLabel: {
              color: 'black'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            interval: 1,
            axisLabel: {
              color: 'black'
            },
            axisLine: {
              show: true
            }
          }
        ],
        series: [
          {
            name: '满分',
            type: 'line',
            data: [8, 6, 6, 10, 10, 5, 5, 7.5, 7.5, 7.5, 7.5, 7, 7, 3, 3],
            symbol: 'circle',
            itemStyle: {
              color: 'rgb(0, 112, 192, 0.5)',
              borderColor: 'rgb(0, 112, 192, 0.5)',
              borderWidth: 2
            },
            lineStyle: {
              color: 'rgb(0, 112, 192, 0.7)'
            }
          },
          {
            name: '评分',
            type: 'line',
            itemStyle: {
              color: 'rgb(227, 108, 10, 0.5)',
              borderColor: 'rgb(227, 108, 10, 0.5)',
              borderWidth: 2
            },
            lineStyle: {
              color: 'rgb(227, 108, 10, 0.7)'
            },
            data: [this.info.answerArr[0].score, this.info.answerArr[1].score, this.info.answerArr[2].score, this.info.answerArr[3].score, this.info.answerArr[4].score, this.info.answerArr[5].score, this.info.answerArr[6].score, this.info.answerArr[7].score, this.info.answerArr[8].score, this.info.answerArr[9].score, this.info.answerArr[10].score, this.info.answerArr[11].score, this.info.answerArr[12].score, this.info.answerArr[13].score, this.info.answerArr[14].score]
          }
        ]
      })
      this.echarts.push(echarts2)
    }
  }
}
</script>
